import { Route } from '@angular/router';
import { FeatureShellComponent, featureShellRoutes } from '@frontend/feature-shell';
import { LoginComponent } from '@frontend/feature-login';

export const appRoutes: Route[] = [
  {
    path: ':lang',
    children: [
      { path: 'login', component: LoginComponent, title: 'PAGE_TITLE.LOGIN' },
      { path: '', component: FeatureShellComponent, children: featureShellRoutes },
    ],
  },
  { path: '**', redirectTo: 'de' },
];
